var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ErrorBox, Modal } from "@components/ui";
import { useSubscribeCustomer } from "@hooks/subscribe-api";
import { Field, Formik } from "formik";
import InputField from "../InputField";
import { SUBSCRIBE_FORM_SCHEMA } from "@schema/index";
var initialValues = {
    email: "",
};
var FallbackModal = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var _b = useSubscribeCustomer(), subscribeCustomer = _b[0], _c = _b[1], data = _c.data, error = _c.error, loading = _c.loading;
    var onSubmit = function (values) {
        subscribeCustomer(values);
    };
    return (_jsx(Modal, __assign({ open: open, onClose: onClose, className: "w-full max-w-xl h-auto p-10 space-y-4 text-center" }, { children: data ? (_jsxs("div", { children: [_jsx("h1", __assign({ className: "font-medium text-lg" }, { children: "LEVERER GRIM TIL DIT OMR\u00C5DE?" }), void 0),
                _jsx("div", __assign({ className: "py-5" }, { children: _jsx("p", { children: "Tak! \uD83D\uDC4D Du er p\u00E5 ventelisten. Vi sender dig en mail s\u00E5 snart vi leverer til dit omr\u00E5de." }, void 0) }), void 0),
                _jsx(Button, __assign({ onClick: onClose, className: "px-8 py-3", primary: true }, { children: "FORTS\u00C6T" }), void 0)] }, void 0)) : (_jsx(Formik, __assign({ initialValues: initialValues, validationSchema: SUBSCRIBE_FORM_SCHEMA, onSubmit: onSubmit }, { children: function (_a) {
                var handleSubmit = _a.handleSubmit;
                return (_jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsx("h1", __assign({ className: "font-medium text-lg" }, { children: "LEVERER GRIM TIL DIT OMR\u00C5DE?" }), void 0),
                        _jsxs("div", __assign({ className: "py-5" }, { children: [error && _jsx(ErrorBox, { children: error }, void 0),
                                _jsx("p", { children: "Vi leverer ikke til dit omr\u00E5de endnu MEN du kan v\u00E6lge selv at hente din kasse, ved at af vores afhentningssteder i K\u00F8benhavn eller Aarhus." }, void 0),
                                _jsx("br", {}, void 0),
                                _jsx("p", { children: "\uD83D\uDC49 Du v\u00E6lger bare Afhentning som din leveringsmetode." }, void 0),
                                _jsx("br", {}, void 0),
                                _jsx("p", { children: "Ellers, kan du skrive dig p\u00E5 vores venteliste og f\u00E5 direkte besked n\u00E5r vi leverer til dit omr\u00E5de." }, void 0),
                                _jsx("br", {}, void 0),
                                _jsxs("div", __assign({ className: "text-left flex space-x-2 w-full" }, { children: [_jsx(Field, { className: "flex-1", type: "text", name: "zip", label: "Postal code", placeholder: "4200", component: InputField }, void 0),
                                        _jsx(Field, { className: "flex-1", type: "email", name: "email", label: "Email", placeholder: "grimlink@eatgrim.com", component: InputField }, void 0)] }), void 0)] }), void 0),
                        _jsx(Button, __assign({ className: "px-8 py-3", primary: true, type: "submit" }, { children: loading
                                ? "Loading..."
                                : "Tilmeld dig ventelisten" }), void 0)] }), void 0));
            } }), void 0)) }), void 0));
};
export default FallbackModal;
